<div class="modal-header" rt="self-haul-info-modal">
  <div></div>
  <h4 class="mb-0">Self-Haul Requirements</h4>
  <i
    class="icon-close text-grey cursor-pointer"
    id="icon-close"
    (click)="cancel()"
  ></i>
</div>
<div class="modal-body p-4">
  <p class="mb-3">
    Have your insurance provider email a
    <strong>Certificate of Insurance (COI)</strong> to
    <a href="mailto:orders@rubbl.com">orders@rubbl.com</a> with the following
    coverages:
  </p>

  <ul class="mb-3">
    <li><strong>General Liability:</strong> $1,000,000</li>
    <li><strong>General Aggregate:</strong> $2,000,000</li>
    <li><strong>Auto Liability:</strong> $1,000,000</li>
    <li class="mt-2">
      With either the <strong>"Any Auto"</strong> box checked, or both
      <strong>"Hired Autos"</strong> and
      <strong>"Non-Owned Autos"</strong> boxes checked
    </li>
  </ul>

  <p class="mb-3">
    <strong>Rubbl Holdings LLC</strong> should be listed as the certificate
    holder:
  </p>

  <address class="mb-3 ml-3">
    <strong>1012 2nd Street, Suite 100</strong><br />
    <strong>Encinitas, CA 92024</strong>
  </address>

  <p class="mb-3">
    We will also need a
    <strong>clear photo of the truck and trailer</strong> you will be using for
    transport.
  </p>

  <p class="mb-0">
    Once we have that on file, you'll be all set to pick up. Let us know if you
    have any questions.
  </p>
</div>

<div class="modal-footer d-flex justify-content-center">
  <button
    type="button"
    class="btn btn-secondary btn-modal-footer"
    (click)="confirm()"
  >
    I Understand
  </button>
</div>
